import * as i0 from "@angular/core";
export class TooltipOperationNumberService {
    constructor() {
        this.tooltipContent = `<div class="bl-tooltip__content">
  <h3 class="bl-tooltip__title">Valid format of loan number</h3>
  <ul class="bl-tooltip__list">
  <li bl-tooltip__item><span class="bl-tooltip__text">####/XX-CC | ####/XX-CC-# </span></li>
  <li bl-tooltip__item><span class="bl-tooltip__text">GRT/XX-####-CC </span></li>
  <li bl-tooltip__item><span class="bl-tooltip__text">GRT/XX-####-CC-# </span></li>
  <li bl-tooltip__item><span class="bl-tooltip__text">ATN/XX-####-CC</span></li>
  </ul>
  </div>`;
    }
    getTooltipContent() {
        return this.tooltipContent;
    }
}
TooltipOperationNumberService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TooltipOperationNumberService_Factory() { return new TooltipOperationNumberService(); }, token: TooltipOperationNumberService, providedIn: "root" });
